module.exports = __webpack_public_path__ + "static/media/hud_animal_marker.1b36838e.svg";